/*
  SMA — Cart drawer upsell carousel.

  Standalone by design: it does not extend or reuse anything from the
  complementary-products block on the product page.

  Handles:
  - scroll-snap carousel paging + dots
  - quick add straight into the cart, re-rendering the drawer afterwards
*/
(function () {
  'use strict';

  if (customElements.get('sma-cart-upsell')) return;

  customElements.define(
    'sma-cart-upsell',
    class SmaCartUpsell extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-sma-upsell-track]');
        this.dotsWrap = this.querySelector('[data-sma-upsell-dots]');
        if (!this.track) return;

        this.slides = Array.prototype.slice.call(this.track.querySelectorAll('.sma-upsell__slide'));
        this.perView = this.classList.contains('sma-upsell--per-2') ? 2 : 1;

        this.buildDots();
        this.bindScroll();
        this.bindQuickAdd();
      }

      get pageCount() {
        return Math.ceil(this.slides.length / this.perView);
      }

      buildDots() {
        if (!this.dotsWrap) return;

        // A single page needs no pagination.
        if (this.pageCount < 2) {
          this.dotsWrap.hidden = true;
          return;
        }

        this.dotsWrap.innerHTML = '';
        for (let i = 0; i < this.pageCount; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'sma-upsell__dot' + (i === 0 ? ' is-active' : '');
          dot.dataset.page = String(i);
          dot.setAttribute('aria-label', String(i + 1));
          this.dotsWrap.appendChild(dot);
        }

        this.dotsWrap.addEventListener('click', (event) => {
          const dot = event.target.closest('.sma-upsell__dot');
          if (!dot) return;
          const target = this.slides[parseInt(dot.dataset.page, 10) * this.perView];
          if (target) {
            this.track.scrollTo({ left: target.offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
          }
        });
      }

      bindScroll() {
        if (!this.dotsWrap || this.pageCount < 2) return;

        let ticking = false;
        this.track.addEventListener(
          'scroll',
          () => {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(() => {
              const slideWidth = this.slides[0] ? this.slides[0].offsetWidth : 1;
              const page = Math.round(this.track.scrollLeft / (slideWidth * this.perView));
              this.dotsWrap.querySelectorAll('.sma-upsell__dot').forEach((dot, i) => {
                dot.classList.toggle('is-active', i === page);
              });
              ticking = false;
            });
          },
          { passive: true }
        );
      }

      bindQuickAdd() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-sma-upsell-add]');
          if (button) this.addToCart(button);
        });
      }

      addToCart(button) {
        if (button.disabled) return;

        const variantId = button.dataset.variantId;
        if (!variantId) return;

        const spinner = button.querySelector('.sma-upsell__spinner');
        button.disabled = true;
        button.classList.add('is-loading');
        if (spinner) spinner.hidden = false;

        const cartDrawer = document.querySelector('cart-drawer');
        const body = {
          items: [{ id: Number(variantId), quantity: 1 }],
        };

        // Ask for the same sections the drawer re-renders itself with, so the
        // updated cart (and this carousel) comes back in one round trip.
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          body.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((parsed) => {
            if (parsed.status) {
              // Shopify returned an error (sold out, etc.) — leave the cart alone.
              this.fail(button, spinner);
              return;
            }

            if (cartDrawer && parsed.sections) {
              cartDrawer.renderContents(parsed);
            } else {
              window.location.reload();
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'sma-cart-upsell',
                productVariantId: variantId,
                cartData: parsed,
              });
            }
          })
          .catch(() => this.fail(button, spinner));
      }

      fail(button, spinner) {
        button.disabled = false;
        button.classList.remove('is-loading');
        if (spinner) spinner.hidden = true;
      }
    }
  );
})();